import logout from './logout.html';

export default /* @ngInject */ function($routeProvider) {
    $routeProvider.when('/logout', {
        templateUrl: logout,
        controller: 'LogoutCtrl',
        controllerAs: 'logout'
    });
}



// WEBPACK FOOTER //
// ./logout/logout-routes.js